import { defineMessages } from 'react-intl';

export const parkingStatusMessages = defineMessages({
    devices: {
        id: 'devices',
        defaultMessage: 'Devices',
    },
    devicesSubtitle: {
        id: 'devices-subtitle',
        defaultMessage: 'See your hardware in action and get an insight on all important events and details',
    },
    monitoring: {
        id: 'monitoring',
        defaultMessage: 'Monitoring',
    },
    payStations: {
        id: 'pay-stations',
        defaultMessage: 'Pay stations',
    },
    gateways: {
        id: 'gateways',
        defaultMessage: 'Gateways',
    },
    currentOperation: {
        id: 'current-operation',
        defaultMessage: 'Current operation',
    },
    currentScreen: {
        id: 'current-screen',
        defaultMessage: 'Current screen',
    },
    totalCashAmount: {
        id: 'total-cash-amount',
        defaultMessage: 'Total cash amount',
    },
    count: {
        id: 'count',
        defaultMessage: 'Count',
    },
    total: {
        id: 'total',
        defaultMessage: 'Total',
    },
    nominal: {
        id: 'nominal',
        defaultMessage: 'Nominal',
    },
    coins: {
        id: 'coins',
        defaultMessage: 'Coins',
    },
    banknotes: {
        id: 'banknotes',
        defaultMessage: 'Banknotes',
    },
    home: {
        id: 'home',
        defaultMessage: 'Home',
    },
    visitorsSearch: {
        id: 'visitors-search',
        defaultMessage: 'Visitors search',
    },
    activeStayPaymentOptions: {
        id: 'active-stay-payment-options',
        defaultMessage: 'Active stay payment options',
    },
    activeStayCardPayment: {
        id: 'active-stay-card-payment',
        defaultMessage: 'Active stay card payment',
    },
    activeStayCashPayment: {
        id: 'active-stay-cash-payment',
        defaultMessage: 'Active stay cash payment',
    },
    activeStayOnlinePayment: {
        id: 'active-stay-online-payment',
        defaultMessage: 'Active stay online payment',
    },
    activeStayPaymentSuccessful: {
        id: 'active-stay-payment-successful',
        defaultMessage: 'Active stay payment successful',
    },
    activeStayFiscalNoteQr: {
        id: 'active-stay-fiscal-note-qr',
        defaultMessage: 'Active stay fiscal note QR',
    },
    chooseLanguage: {
        id: 'choose-language',
        defaultMessage: 'Choose language',
    },
    help: {
        id: 'help',
        defaultMessage: 'Help',
    },
    settings: {
        id: 'settings',
        defaultMessage: 'Settings',
    },
    fiscalServices: {
        id: 'fiscal-services',
        defaultMessage: 'Fiscal services',
    },
    coinServices: {
        id: 'coin-services',
        defaultMessage: 'Coin services',
    },
    banknoteServices: {
        id: 'banknote-services',
        defaultMessage: 'Banknote services',
    },
    systemInformation: {
        id: 'system-information',
        defaultMessage: 'System information',
    },
    subscriptionSearch: {
        id: 'subscription-search',
        defaultMessage: 'Subscription search',
    },
    subscriptionPlans: {
        id: 'subscription-plans',
        defaultMessage: 'Subscription plans',
    },
    subscriptionDetails: {
        id: 'subscription-details',
        defaultMessage: 'Subscription details',
    },
    subscriptionStart: {
        id: 'subscription-start',
        defaultMessage: 'Subscription start',
    },
    subscriptionPayment: {
        id: 'subscription-payment',
        defaultMessage: 'Subscription payment',
    },
    subscriptionCashPayment: {
        id: 'subscription-cash-payment',
        defaultMessage: 'Subscription cash payment',
    },
    subscriptionCardPayment: {
        id: 'subscription-card-payment',
        defaultMessage: 'Subscription card payment',
    },
    subscriptionPaymentSuccessful: {
        id: 'subscription-payment-successful',
        defaultMessage: 'Subscription payment successful',
    },
    subscriptionOptions: {
        id: 'subscription-options',
        defaultMessage: 'Subscription options',
    },
    openDashboard: {
        id: 'open-dashboard',
        defaultMessage: 'Open dashboard',
    },
    expandAll: {
        id: 'expand-all',
        defaultMessage: 'Expand all',
    },
    collapseAll: {
        id: 'collapse-all',
        defaultMessage: 'Collapse all',
    },
    totalPassesToday: {
        id: 'total-passes-today',
        defaultMessage: 'Total passes today',
    },
    failedPassesToday: {
        id: 'failed-passes-today',
        defaultMessage: 'Failed passes today',
    },
    exitZone: {
        id: 'exit-zone',
        defaultMessage: 'Exit zone',
    },
    entryZone: {
        id: 'entry-zone',
        defaultMessage: 'Entry zone',
    },
    currentVisitor: {
        id: 'current-visitor',
        defaultMessage: 'Current visitor',
    },
    lastVisitor: {
        id: 'last-visitor',
        defaultMessage: 'Last visitor',
    },
    requiredIdentifiers: {
        id: 'required-identifiers',
        defaultMessage: 'Required identifiers',
    },
    message: {
        id: 'message',
        defaultMessage: 'Message',
    },
    raise: {
        id: 'raise',
        defaultMessage: 'Raise',
    },
    emergencyRaise: {
        id: 'emergency-raise',
        defaultMessage: 'Raise',
    },
    emergencyClose: {
        id: 'emergency-close',
        defaultMessage: 'Close',
    },
    lock: {
        id: 'lock',
        defaultMessage: 'Lock',
    },
    free: {
        id: 'free',
        defaultMessage: 'Free',
    },
    busy: {
        id: 'busy',
        defaultMessage: 'Busy',
    },
    state: {
        id: 'state',
        defaultMessage: 'State',
    },
    opened: {
        id: 'opened',
        defaultMessage: 'Opened',
    },
    closed: {
        id: 'closed',
        defaultMessage: 'Closed',
    },
    notAvailable: {
        id: 'not-available',
        defaultMessage: 'N/A',
    },
    frontLoop: {
        id: 'front-loop',
        defaultMessage: 'Front loop',
    },
    centerLoop: {
        id: 'center-loop',
        defaultMessage: 'Center loop',
    },
    backLoop: {
        id: 'back-loop',
        defaultMessage: 'Back loop',
    },
    loopActive: {
        id: 'loop-active',
        defaultMessage: 'Active',
    },
    loopInactive: {
        id: 'loop-inactive',
        defaultMessage: 'Inactive',
    },
    emergencyOpenNotConfigured: {
        id: 'emergency-open-not-configured',
        defaultMessage: 'This gateway has no persistent channel configured.',
    },
    timeElapsed: {
        id: 'time-elapsed',
        defaultMessage: 'Time elapsed',
    },
    warningsCount: {
        id: 'monitoring-warnings-count',
        defaultMessage: '{count, plural, one {# warning} other {# warnings}}',
    },
    criticalErrorsCount: {
        id: 'monitoring-critical-errors-count',
        defaultMessage: '{count, plural, one {# critical error} other {# critical errors}}',
    },
    issueStarted: {
        id: 'monitoring-issue-started',
        defaultMessage: 'Started {time}',
    },
    issueSourcePaystationEvent: {
        id: 'monitoring-issue-source-paystation-event',
        defaultMessage: 'Pay station event',
    },
    issueSourceHeartbeat: {
        id: 'monitoring-issue-source-heartbeat',
        defaultMessage: 'Ping',
    },
    issueSourcePeriodicCheck: {
        id: 'monitoring-issue-source-periodic-check',
        defaultMessage: 'Periodic check',
    },
    issueSourceSelfReport: {
        id: 'monitoring-issue-source-self-report',
        defaultMessage: 'Self report',
    },
    issueSourceDocker: {
        id: 'monitoring-issue-source-docker',
        defaultMessage: 'Docker',
    },
    issueSourceManual: {
        id: 'monitoring-issue-source-manual',
        defaultMessage: 'Manual',
    },
    issueSourceUnknown: {
        id: 'monitoring-issue-source-unknown',
        defaultMessage: 'Unknown source',
    },
    raiseGatewayBarrier: {
        id: 'raise-gateway-barrier',
        defaultMessage: 'Raise gateway barrier {entry}',
    },
    raiseGatewayBarrierDescription: {
        id: 'raise-gateway-barrier-description',
        defaultMessage: 'Raise gateway barrier',
    },
    raiseGatewayBarrierText: {
        id: 'raise-gateway-barrier-text',
        defaultMessage: 'Are you sure you want to raise gateway barrier {entry}?',
    },
    emergencyRaiseGatewayBarrier: {
        id: 'emergency-raise-gateway-barrier',
        defaultMessage: 'Emergency raise gateway barrier {entry}',
    },
    emergencyRaiseGatewayBarrierDescription: {
        id: 'emergency-raise-gateway-barrier-description',
        defaultMessage: 'Emergency raise gateway barrier',
    },
    emergencyRaiseGatewayBarrierText: {
        id: 'emergency-raise-gateway-barrier-text',
        defaultMessage: 'Are you sure you want to emergency raise gateway barrier {entry}?',
    },
    emergencyCloseGatewayBarrier: {
        id: 'emergency-close-gateway-barrier',
        defaultMessage: 'Emergency close gateway barrier {entry}',
    },
    emergencyCloseGatewayBarrierDescription: {
        id: 'emergency-close-gateway-barrier-description',
        defaultMessage: 'Emergency close gateway barrier',
    },
    emergencyCloseGatewayBarrierText: {
        id: 'emergency-close-gateway-barrier-text',
        defaultMessage: 'Are you sure you want to emergency close gateway barrier {entry}?',
    },
    lockGatewayBarrier: {
        id: 'lock-gateway-barrier',
        defaultMessage: 'Lock gateway barrier {entry}',
    },
    lockGatewayBarrierDescription: {
        id: 'lock-gateway-barrier-description',
        defaultMessage: 'Lock gateway barrier',
    },
    lockGatewayBarrierText: {
        id: 'lock-gateway-barrier-text',
        defaultMessage: 'Are you sure you want to lock gateway barrier {entry}?',
    },
    gatewayBarrierRaised: {
        id: 'gateway-barrier-raised',
        defaultMessage: 'The gateway barrier was raised',
    },
    gatewayBarrierRaisedDescription: {
        id: 'gateway-barrier-raised-description',
        defaultMessage: 'The gateway barrier {entry} was successfully raised',
    },
    gatewayCommandNotSent: {
        id: 'gateway-command-not-sent',
        defaultMessage: 'The command did not reach the gateway barrier',
    },
    gatewayBarrierClosed: {
        id: 'gateway-barrier-closed',
        defaultMessage: 'The gateway barrier was closed',
    },
    gatewayBarrierClosedDescription: {
        id: 'gateway-barrier-closed-description',
        defaultMessage: 'The gateway barrier {entry} was successfully closed',
    },
    gatewayBarrierLocked: {
        id: 'gateway-barrier-locked',
        defaultMessage: 'The gateway barrier was locked',
    },
    gatewayBarrierLockedDescription: {
        id: 'gateway-barrier-locked-description',
        defaultMessage: 'The gateway barrier {entry} was successfully locked',
    },
    fiscalNoteQr: {
        id: 'fiscal-note-qr',
        defaultMessage: 'Fiscal note QR',
    },
    subscriptionPaymentOptions: {
        id: 'subscription-payment-options',
        defaultMessage: 'Subscription payment options',
    },
    cashServices: {
        id: 'cash-services',
        defaultMessage: 'Cash services',
    },
});
